import Vue from "vue";
import VueRouter from "vue-router";
import { isLoggedIn } from "../utils/auth"; // 导入校验函数
import WebIndex from "../views/WebIndex.vue";
import LoginRegister from "../views/LoginRegister.vue";
import AboutMe from "../views/AboutMe.vue";
import Profile from "../views/personal/Profile.vue";
import PhoneEdit from "../views/personal/ProfilePhoneEdit.vue";
import MerchantAuth from "../views/personal/MerchantAuth.vue";
import MerchantAuthUpload from "../views/personal/MerchantAuthUpload.vue";
import TravelRoutePublish from "../views/travel/TravelRoutePublish.vue";
import TravelPublish from "../views/travel/TravelPublish.vue";
import TravelRouteDetail from "../views/travel/TravelRouteDeatail.vue";
import TravelRouteList from "../views/travel/TravelRouteList.vue";
import TouristLists from "../views/personal/TouristLists.vue";
import OrderList from "../views/personal/OrderList.vue";
import FavoriteList from "../views/personal/FavoriteList.vue";
import TravelEvaluation from "../views/personal/TravelEvaluation.vue";
import TravelBooking from "../views/travel/TravelBooking.vue";
import PaymentPage from "../views/PaymentPage.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "WebIndex",
    component: WebIndex,
    meta: {
      inheritHeader: true, // 继承公共头部
      inheritFooter: true, // 继承公共尾部
      requiresAuth: false, // 是否需要登录
    },
  },
  {
    path: "/login-register",
    name: "LoginRegister",
    component: LoginRegister,
    meta: {
      inheritHeader: true, // 继承公共头部
      inheritFooter: false, // 继承公共尾部
      requiresAuth: false,
    },
  },
  {
    path: "/about-me",
    component: AboutMe,
    meta: {
      inheritHeader: true, // 继承公共头部
      inheritFooter: true, // 继承公共尾部
      requiresAuth: true,
    },
    children: [
      {
        path: "", // 默认为profile
        component: Profile,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "profile",
        component: Profile,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "phone-edit",
        component: PhoneEdit,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "merchant-auth",
        component: MerchantAuth,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "merchant-auth-upload",
        component: MerchantAuthUpload,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "my-listings/tourist-lists",
        component: TouristLists,
        meta: {
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "my-listings/order-list",
        component: OrderList,
        meta: {
          requiresAuth: true,
          keepAlive: true,
        },
      },
      {
        path: "my-listings/evaluation",
        component: TravelEvaluation,
        meta: {
          inheritHeader: true,
          inheritFooter: true,
        },
      },
      {
        path: "my-listings/favorite-list",
        component: FavoriteList,
        meta: {
          requiresAuth: true,
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/travel/route-publish",
    name: "TravelRoutePublish",
    component: TravelRoutePublish,
    meta: {
      inheritHeader: true,
      inheritFooter: true,
      requiresAuth: true,
    },
  },
  {
    path: "/travel/publish",
    name: "TravelPublish",
    component: TravelPublish,
    meta: {
      inheritHeader: true,
      inheritFooter: true,
      requiresAuth: true,
    },
  },
  {
    path: "/travel/route-detail",
    name: "TravelRouteDeatil",
    component: TravelRouteDetail,
    meta: {
      inheritHeader: true,
      inheritFooter: true,
    },
  },
  {
    path: "/travel/route-list",
    name: "TravelRouteList",
    component: TravelRouteList,
    meta: {
      keepAlive: true, // 关键：标记该页面需要被缓存
      inheritHeader: true,
      inheritFooter: true,
      requiresAuth: false,
    },
  },
  {
    path: "/travel/booking",
    name: "TravelBooking",
    component: TravelBooking,
    meta: {
      inheritHeader: true,
      inheritFooter: true,
      requiresAuth: true,
    },
  },
  {
    path: "/payment/middle", // 路由路径，需与二维码中的 URL 路径一致
    name: "PaymentPage",
    component: PaymentPage,
    meta: {
      title: "订单支付", // 页面标题
      inheritHeader: false,
      inheritFooter: false,
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const isLogin = isLoggedIn();
    if (isLogin) {
      next();
    } else {
      next({
        path: "/login-register",
        query: { redirect: to.fullPath },
      });
    }
  } else {
    next();
  }
});
export default router;
